import { Trans } from "@lingui/react/macro";

export function UnattachedItem() {
    return (
        <i>
            <Trans>Detached</Trans>
        </i>
    );
}
